module.exports = __webpack_public_path__ + "static/code-994561dd8194c29b2eb743c7aeb2a7b4.png";